import { Injectable } from '@angular/core';
import { SocketMiddlewareService } from './socket-middleware.service';
import { SystemColorEvents } from 'icreate/common/io-event/websocket-message';

@Injectable({
    providedIn: 'root',
})
export class SystemColorSocketService {
    constructor(private socketService: SocketMiddlewareService) {}

    systemColorCreated$() {
        return this.socketService.receiveMessageObserver(SystemColorEvents.SYSTEM_COLOR_CREATED);
    }

    systemColorUpdated$() {
        return this.socketService.receiveMessageObserver(SystemColorEvents.SYSTEM_COLOR_UPDATED);
    }

    systemColorDeleted$() {
        return this.socketService.receiveMessageObserver(SystemColorEvents.SYSTEM_COLOR_DELETED);
    }

    systemColorInit$() {
        return this.socketService.receiveMessageObserver(SystemColorEvents.SYSTEM_COLOR_INIT);
    }
}
